import VVideosPlayers from "./index";
import Vue from "vue";

export default function (data) {
  document.querySelector("#video-player-box")?.remove?.();
  const div = document.createElement("div");
  const el = document.createElement("div");
  div.id = "video-player-box";
  div.appendChild(el);
  document.body.appendChild(div);

  let instance = null;

  function render() {
    instance = new Vue({
      el,
      components: { VVideosPlayers },
      data() {
        this.data = data;
        return {
          vIf: false,
        };
      },
      methods: {
        on_close() {
          this.vIf = false;
        },
        on_destroy() {
          instance = null;
          div.parentNode.removeChild(div);
          //  取消禁止页面滚动
          document.body.classList.remove("disabled-scroll");
        },
      },
      created() {
        this.$nextTick(() => {
          this.vIf = true;
        });
      },
      render() {
        return (
          <transition name="fade" vOn:after-leave={this.on_destroy}>
            {this.vIf ? (
              <VVideosPlayers
                currentVideoData={data}
                vOn:close={this.on_close}
              />
            ) : null}
          </transition>
        );
      },
    });
  }

  render();
}
